import UploadSharedFileModal from './UploadSharedFileModal';
import UploadedFile from './UploadedFile';
import UserFileList from './UserFileList';

export const commonComponents = {
  UploadedFile,
  UploadSharedFileModal,
  UserFileList,
};
